var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_481)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.625C7.7224 2.625 2.625 7.7224 2.625 14C2.625 20.2776 7.7224 25.375 14 25.375C20.2776 25.375 25.375 20.2776 25.375 14C25.375 7.7224 20.2776 2.625 14 2.625ZM14 4.375C19.3116 4.375 23.625 8.6884 23.625 14C23.625 19.3116 19.3116 23.625 14 23.625C8.6884 23.625 4.375 19.3116 4.375 14C4.375 8.6884 8.6884 4.375 14 4.375Z",
    fill: "#FC2E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18.375C16.4162 18.375 18.375 16.4162 18.375 14C18.375 11.5838 16.4162 9.625 14 9.625C11.5838 9.625 9.625 11.5838 9.625 14C9.625 16.4162 11.5838 18.375 14 18.375Z",
    fill: "#FC2E00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 0.86192V6.11105C13.125 6.59397 13.517 6.98615 14 6.98615C14.483 6.98615 14.875 6.59397 14.875 6.11105V0.86192C14.875 0.379001 14.483 -0.0131836 14 -0.0131836C13.517 -0.0131836 13.125 0.379001 13.125 0.86192Z",
    fill: "#FC2E00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1383 13.125H21.8892C21.4063 13.125 21.0141 13.517 21.0141 14C21.0141 14.483 21.4063 14.875 21.8892 14.875H27.1383C27.6212 14.875 28.0134 14.483 28.0134 14C28.0134 13.517 27.6212 13.125 27.1383 13.125Z",
    fill: "#FC2E00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 24.5393V27.1669C13.125 27.6504 13.517 28.0427 14 28.0427C14.483 28.0427 14.875 27.6504 14.875 27.1669V24.5393C14.875 24.0558 14.483 23.6636 14 23.6636C13.517 23.6636 13.125 24.0558 13.125 24.5393Z",
    fill: "#FC2E00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13832 13.125H0.889199C0.406279 13.125 0.0140948 13.517 0.0140948 14C0.0140948 14.483 0.406279 14.875 0.889199 14.875H6.13832C6.62124 14.875 7.01343 14.483 7.01343 14C7.01343 13.517 6.62124 13.125 6.13832 13.125Z",
    fill: "#FC2E00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1007 22.442C7.04382 22.7745 7.18295 23.1105 7.45945 23.3048C9.31008 24.6094 11.5667 25.375 14.0001 25.375C16.4343 25.375 18.6909 24.6085 20.5416 23.3048C20.8172 23.1105 20.9572 22.7745 20.9003 22.442C20.3377 19.1397 17.4624 16.625 14.0001 16.625H13.9983C12.1425 16.625 10.3618 17.3626 9.0502 18.6751C8.01945 19.705 7.34307 21.0245 7.1007 22.442Z",
    fill: "#FC2E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.18669e5bc44fdcd4cf7b3d9e0e3cb0d0.svg";
export { ForwardRef as ReactComponent };